import { ReactNode, createContext, useState } from "react";

type OrganizationContextType = {
  showMask: boolean;
  setShowMask: (newState: boolean) => void;
  users: any[];
  setUsers: (users: any[]) => void;
  selectedUser: any;
  setSelectedUser: (user: any) => void;
};

const initialValue = {
  showMask: false,
  setShowMask: () => {},
  users: [],
  setUsers: () => {},
  selectedUser: null,
  setSelectedUser: () => {},
};

export const OrganizationContext =
  createContext<OrganizationContextType>(initialValue);

export default function OrganizationProvider({
  children,
}: {
  children?: ReactNode;
}) {
  const [showMask, setShowMask] = useState(initialValue.showMask);
  const [users, setUsers] = useState(initialValue.users);
  const [selectedUser, setSelectedUser] = useState(initialValue.selectedUser);

  return (
    <OrganizationContext.Provider
      value={{
        showMask,
        setShowMask,
        users,
        setUsers,
        selectedUser,
        setSelectedUser,
      }}
    >
      {children}
    </OrganizationContext.Provider>
  );
}
